// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* style-for-Profile-chart */
img {
  max-width: 100%;
}

.flex {
  display: flex;
  flex-wrap: wrap;
}

.dir-col {
  flex-direction: column;
}

.dir-col-rev {
  flex-direction: column-reverse;
}

.mh-full {
  min-height: 100%;
}

.mt-auto {
  margin-top: auto;
}

.bt-0 {
  border-top: 0;
}

.bb-0 {
  border-bottom: 0;
}

.fn-body h1,
.fn-body h2,
.fn-body h3,
.fn-body h4,
.fn-body h5,
.fn-body h6 {
  --hGap: 10px;
  font-family: "Museo-700";
  color: #6d6e71;
  margin-bottom: var(--hGap);
  margin-top: 0;
}
.fn-body h1:last-child,
.fn-body h2:last-child,
.fn-body h3:last-child,
.fn-body h4:last-child,
.fn-body h5:last-child,
.fn-body h6:last-child {
  margin-bottom: 0;
}
.fn-body h1,
.fn-body .h1-text {
  font-size: 44px;
  line-height: 1.1;
}
@media only screen and (max-width: 767px) {
  .fn-body h1,
  .fn-body .h1-text {
    font-size: 38px;
  }
}
.fn-body h2,
.fn-body .h2-text {
  font-size: 38px;
  line-height: 1.2;
}
@media only screen and (max-width: 767px) {
  .fn-body h2,
  .fn-body .h2-text {
    font-size: 32px;
  }
}
.fn-body h3,
.fn-body .h3-text {
  font-size: 32px;
  line-height: 1.2;
}
@media only screen and (max-width: 767px) {
  .fn-body h3,
  .fn-body .h3-text {
    font-size: 24px;
  }
}
.fn-body h4,
.fn-body .h4-text {
  font-size: 24px;
  line-height: 1.2;
}
.fn-body h5,
.fn-body .h5-text {
  font-size: 18px;
  line-height: 1.2;
}
.fn-body h6,
.fn-body .h6-text {
  font-size: 16px;
  line-height: 1.3;
}
.fn-body p {
  font-size: 18px;
  line-height: 1.6;
  color: #6a6a6a;
  margin-top: 0;
  margin-bottom: 10px;
}
.fn-body p:last-child {
  margin-bottom: 0;
}
@media only screen and (max-width: 767px) {
  .fn-body p {
    font-size: 16px;
  }
}
.fn-body ul,
.fn-body ol {
  padding: 0;
  margin: 0;
}
.fn-body sup {
  font-size: 0.7em;
  position: relative;
  top: 5px;
  display: inline-block;
  vertical-align: top;
}

.bg-grey {
  background-color: #eee;
}

.fn-container {
  max-width: 1080px;
  width: calc(100% - 30px);
  margin-inline: auto;
}
@media only screen and (min-width: 992px) {
  .fn-container {
    margin-left: 0;
  }
}
.fn-container--fluid {
  max-width: 1200px;
}
.fn-container--small {
  max-width: 820px;
  width: 100%;
}

.text-center {
  text-align: center;
}
.text-right {
  text-align: right;
}

.d-none {
  display: none;
}

.section-title {
  text-align: center;
}
.section-title:not(:last-child) {
  margin-bottom: 40px;
}
.section-title h2:not(:last-child) {
  margin-block-end: 20px;
}
.section-title p {
  max-width: 900px;
  width: 100%;
  margin-inline: auto;
  font-size: 22px;
}
.section-title p:not(:last-child) {
  margin-block-end: 20px;
}
@media only screen and (max-width: 767px) {
  .section-title p {
    font-size: 18px;
  }
}
.section-title .section-title__linkcontainer {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
}
.section-title .section-title__linkcontainer:not(:last-child) {
  margin-block-end: 20px;
}
.section-title .section-title__linkcontainer > * {
  margin: 5px;
}
.section-title .section-title__linkcontainer .fn-btn {
  padding-block: 6px;
  padding-inline: 13px;
  font-size: 12px;
  font-family: "MuseoSans-300";
}

.section-padding {
  padding-block: 60px;
}
@media only screen and (max-width: 767px) {
  .section-padding {
    padding-block: 40px;
  }
}
.section-padding-small {
  padding-block: 30px;
}
.section-padding-all {
  padding: 60px;
}
@media only screen and (max-width: 767px) {
  .section-padding-all {
    padding: 30px;
  }
}
.section-padding-all-small {
  padding: 30px;
}

.headline {
  --lineSize: 10px;
  width: -moz-fit-content;
  width: fit-content;
  padding-block-end: calc(10px + var(--lineSize));
  margin-inline: auto;
  position: relative;
}
.headline--small-border {
  --lineSize: 6px;
}
.headline:not(:last-child) {
  margin-bottom: calc(var(--hGap) * 2.5);
}
.headline::before {
  content: "";
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: var(--lineSize);
  background: linear-gradient(90deg, rgb(0, 173, 208) 0%, rgb(0, 173, 208) 25%, rgb(255, 121, 0) 25%, rgb(255, 121, 0) 50%, rgb(105, 190, 40) 50%, rgb(105, 190, 40) 75%, rgb(245, 67, 89) 75%, rgb(245, 67, 89) 100%);
}

.custom-list li {
  font-size: 18px;
  line-height: 1.4;
  color: #6a6a6a;
  list-style: none;
  position: relative;
  padding-left: 15px;
}
.custom-list li:not(:last-child) {
  margin-bottom: 4px;
}
.custom-list li::before {
  content: "";
  position: absolute;
  top: 10px;
  left: 0;
  width: 3px;
  height: 3px;
  background-color: var(--clrProfile);
}

.color-clarify {
  --clrProfile: rgb(0, 173, 208);
}

.color-ideate {
  --clrProfile: rgb(255, 121, 0);
}

.color-develop {
  --clrProfile: rgb(105, 190, 40);
}

.color-implement {
  --clrProfile: rgb(245, 67, 89);
}

.fn-btn {
  padding-block: 20px;
  padding-inline: 28px;
  background-color: rgb(105, 190, 40);
  color: #fff;
  font-size: 18px;
  line-height: 1.2;
  display: inline-block;
  font-family: "Museo-700";
  text-decoration: none;
  word-break: break-all;
  text-align: center;
  transition: background-color 0.3s;
}
.fn-btn:focus {
  outline: 1px dashed #6a6a6a;
  outline-offset: 4px;
}
.fn-btn:hover {
  background-color: #6d6e71;
  color: #fff;
}
.fn-btn--sm {
  font-size: 14px;
  padding-block: 10px;
  padding-inline: 20px;
}
.fn-btn--grey {
  background-color: #f1f1f2;
  color: #6d6e71;
}
.fn-btn--ongoing {
  background-color: #f8ac59;
  color: #fff;
}
.fn-btn--ongoing i {
  animation: spin 0.3s infinite;
}

@keyframes spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}
.color-clarify {
  --clrProfile: rgb(0, 173, 208);
}

.color-ideate {
  --clrProfile: rgb(255, 121, 0);
}

.color-develop {
  --clrProfile: rgb(105, 190, 40);
}

.color-implement {
  --clrProfile: rgb(245, 67, 89);
}

.w-4 {
  width: 33.3333333333%;
}

.w-3 {
  width: 25%;
}
.w-3--wd {
  width: 33.3333333333%;
}

.w-6 {
  width: 50%;
}

.fn-row {
  --rGap: 15px;
  --rGap-minus: calc(-1 * var(--rGap));
  display: flex;
  flex-wrap: wrap;
  margin-inline: var(--rGap-minus);
}
.fn-row--col-gap-exist .fn-col {
  margin-bottom: 30px;
}
.fn-col {
  padding-inline: var(--rGap);
}
.fn-justify-center {
  justify-content: center;
}
.fn-items-center {
  align-items: center;
}

.mx-auto {
  margin-inline: auto;
}
.ml-auto {
  margin-inline-start: auto;
}
.ml-0 {
  margin-inline-start: 0;
}
.mr-auto {
  margin-inline-end: auto;
}
.mr-0 {
  margin-inline-end: 0;
}

::ng-deep .chart-section {
  width: 90%;
  margin: 5% auto 0 auto;
  padding-bottom: 20px;
  /*------background colors used in chart---------*/
  /*------chart area wrapper---------*/
  /*------main chart wrapper---------*/
  /*------y dividers css---------*/
  /*------x dividers css---------*/
  /*------chart labels css---------*/
  /*------preferences css---------*/
  /*------neutral bar css---------*/
  /*------chart titles css---------*/
  /*------chart pointers css---------*/
  /*------chart pointers css end---------*/
  /*------connector css start---------*/
  /*------connector css end---------*/
  /*------highlighter css start---------*/
  /*------highlighter css end---------*/
}
::ng-deep .chart-section .blue-bg {
  background-color: rgb(0, 173, 208) !important;
}
::ng-deep .chart-section .orange-bg {
  background-color: rgb(255, 121, 0) !important;
}
::ng-deep .chart-section .green-bg {
  background-color: rgb(105, 190, 40) !important;
}
::ng-deep .chart-section .purple-bg {
  background-color: rgb(245, 67, 89) !important;
}
::ng-deep .chart-section .chart-main {
  width: 100%;
  height: 250px;
  display: table;
  border-collapse: collapse;
  margin: 0 auto;
  float: none;
  position: relative;
}
::ng-deep .chart-section .y-dividers {
  display: table;
  border-collapse: collapse;
  width: 100%;
  height: 100%;
  left: 0px;
  top: 0px;
  border: 3px solid #d1d2d4;
}
@media screen and (-ms-high-contrast: active), (-ms-high-contrast: none) {
  ::ng-deep .chart-section .y-dividers {
    position: absolute;
  }
}
::ng-deep .chart-section .dividers-yxis {
  border-right: 1px solid #eee;
  border-collapse: collapse;
  display: table-cell;
  width: 20%;
  table-layout: fixed;
  position: relative;
}
::ng-deep .chart-section .dividers-yxis:first-child {
  border-left: 1px solid #eee;
}
::ng-deep .chart-section .x-dividers {
  display: block;
  border-collapse: collapse;
  width: 100%;
  height: 100%;
  position: absolute;
  left: 0;
  top: 0;
}
.owl-carousel ::ng-deep .chart-section .x-dividers {
  backface-visibility: hidden;
}
::ng-deep .chart-section .dividers-xxis {
  border-collapse: collapse;
  width: 100%;
  height: 20%;
  border-bottom: 1px solid #eee;
  position: relative;
}
::ng-deep .chart-section .dividers-xxis:first-child {
  border-top: 1px solid #eee;
}
::ng-deep .chart-section .side-label {
  font-size: 16px;
  color: rgba(0, 0, 0, 0.4) !important;
  position: absolute;
  left: -25px;
  top: -8px;
  text-align: right;
  width: 20px;
}
::ng-deep .chart-section .label-0 {
  position: absolute;
  top: inherit;
  bottom: -8px;
}
::ng-deep .chart-section .preference {
  position: absolute;
  width: 100%;
  height: 100%;
  left: 0;
  top: 0;
  padding: 0 30px;
  font-size: 16px;
  font-weight: 500;
}
::ng-deep .chart-section .high_prefer {
  position: absolute;
  top: 20px;
  color: rgba(0, 0, 0, 0.4) !important;
  left: 30px;
}
::ng-deep .chart-section .low_prefer {
  position: absolute;
  bottom: 20px;
  color: rgba(0, 0, 0, 0.4) !important;
  left: 30px;
}
::ng-deep .chart-section .neutral {
  display: block;
  margin-left: -30px;
  margin-right: -30px;
  background: #e3e3e3 !important;
  position: absolute;
  padding-left: 30px;
  /*   padding-top: 5px;
     padding-bottom: 5px;*/
  z-index: 1;
  width: 100%;
  text-align: left;
}
::ng-deep .chart-section .neutralBartext {
  top: 50%;
  left: 20px !important;
  transform: translateY(-50%);
}
::ng-deep .chart-section .neutral span {
  position: absolute;
  left: 0;
  font-size: 12px;
}
::ng-deep .chart-section .neutral_high_value {
  top: -15px;
}
::ng-deep .chart-section .neutral_low_value {
  bottom: -15px;
}
::ng-deep .chart-section .chart-title {
  text-transform: uppercase;
  font-size: 14px;
  color: #fff !important;
  display: inline-block;
  padding: 5px;
  width: 110px;
  text-align: center;
  position: absolute;
  bottom: -23px;
  right: -55px;
  cursor: pointer;
  z-index: 99;
}
html.mac.safari ::ng-deep .chart-section .chart-title {
  bottom: -45px;
}
::ng-deep .chart-section .chart-title.blue-bg:before,
::ng-deep .chart-section .chart-title.orange-bg:before,
::ng-deep .chart-section .chart-title.green-bg:before,
::ng-deep .chart-section .chart-title.purple-bg:before {
  content: "";
  position: absolute;
  top: -10px;
  left: 0;
  width: 0;
  height: 0;
  border-style: solid;
  line-height: 0px;
  border-width: 0 55px 10px 55px;
  _filter: progid:DXImageTransform.Microsoft.Chroma(color="#000000");
}
::ng-deep .chart-section .chart-title.blue-bg:before {
  border-color: transparent transparent rgb(0, 173, 208) transparent;
  _border-color: #000000 #000000 rgb(0, 173, 208) #000000;
}
::ng-deep .chart-section .chart-title.orange-bg:before {
  border-color: transparent transparent rgb(255, 121, 0) transparent;
  _border-color: #000000 #000000 rgb(255, 121, 0) #000000;
}
::ng-deep .chart-section .chart-title.green-bg:before {
  border-color: transparent transparent rgb(105, 190, 40) transparent;
  _border-color: #000000 #000000 rgb(105, 190, 40) #000000;
}
::ng-deep .chart-section .chart-title.purple-bg:before {
  border-color: transparent transparent rgb(245, 67, 89) transparent;
  _border-color: #000000 #000000 rgb(245, 67, 89) #000000;
}
::ng-deep .chart-section .chart_pointers {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  z-index: 5;
}
::ng-deep .chart-section .pointer {
  width: 35px;
  height: 35px;
  border-radius: 50%;
  display: inline-block;
  position: absolute;
  left: 0;
  bottom: 0;
  color: #fff !important;
  font-weight: 600;
  font-size: 16px;
  text-align: center;
  line-height: 35px;
  transform: translateY(-50%);
  margin-bottom: -35px;
}
::ng-deep .chart-section .pointer.clarify_pointer {
  left: -ms-calc(20% - 17px);
  left: calc(20% - 17px);
}
::ng-deep .chart-section .pointer.ideate_pointer {
  left: -ms-calc(40% - 17px);
  left: -o-calc(40% - 17px);
  left: calc(40% - 17px);
}
::ng-deep .chart-section .pointer.develop_pointer {
  left: -ms-calc(60% - 17px);
  left: -o-calc(60% - 17px);
  left: calc(60% - 17px);
}
::ng-deep .chart-section .pointer.implement_pointer {
  left: -ms-calc(80% - 17px);
  left: -o-calc(80% - 17px);
  left: calc(80% - 17px);
}
::ng-deep .chart-section .connectors {
  width: 100%;
  height: 100%;
  position: absolute;
  left: 0;
  top: 0;
}
::ng-deep .chart-section .connector_block {
  position: absolute;
  top: 0;
  bottom: 0;
  width: 20%;
  z-index: 4;
}
::ng-deep .chart-section .block1 {
  margin-left: 20%;
}
::ng-deep .chart-section .block2 {
  margin-left: 60%;
}
::ng-deep .chart-section .block3 {
  margin-left: 40%;
}
::ng-deep .chart-section .connector_line {
  position: absolute;
  width: 8px;
  margin-top: -15px;
  background-color: #656668 !important;
}
::ng-deep .chart-section .connector_point {
  position: absolute;
  transform: translateY(-50%);
  width: 35px;
  height: 35px;
  margin-bottom: -35px;
}
::ng-deep .chart-section #connector_clarify_pointer, ::ng-deep .chart-section #connector_develop_pointer, ::ng-deep .chart-section #mid_connector_1 {
  left: -17px;
}
::ng-deep .chart-section #connector_ideate_pointer, ::ng-deep .chart-section #connector_implement_pointer, ::ng-deep .chart-section #mid_connector_2 {
  right: -17px;
}
::ng-deep .chart-section .highlighter-wrap {
  position: absolute;
  left: 0;
  top: -10%;
  bottom: -20%;
  width: 100%;
  z-index: 5;
}
::ng-deep .chart-section .highlighter {
  width: 30%;
  max-width: 200px;
  height: 100%;
  border-radius: 50%;
  position: absolute;
  top: 0;
  transform: translateX(-50%);
}
::ng-deep .chart-section .highlighter.clarify_active {
  background-color: rgba(21, 165, 207, 0.25) !important;
  left: 20%;
}
::ng-deep .chart-section .highlighter.ideate_active {
  background-color: rgba(249, 121, 19, 0.25) !important;
  left: 40%;
}
::ng-deep .chart-section .highlighter.develop_active {
  background-color: rgba(97, 194, 11, 0.25) !important;
  left: 60%;
}
::ng-deep .chart-section .highlighter.implement_active {
  background-color: rgba(238, 40, 69, 0.25) !important;
  left: 80%;
}
::ng-deep .chart-section .hidden-xs {
  display: block;
}
::ng-deep .chart-section .visible-xs {
  display: none;
}
::ng-deep .chart-section .chart-title.sm .visible-xs {
  display: block !important;
}
::ng-deep .chart-section .chart-title.sm .hidden-xs {
  display: none !important;
}
::ng-deep .chart-section .chart-title.sm {
  width: 52px;
  padding-left: 10px;
  padding-right: 10px;
  white-space: nowrap;
  text-overflow: ellipsis;
  right: -25px;
  text-transform: capitalize;
  font-size: 14px;
}
::ng-deep .chart-section .chart-title.blue-bg.sm:before,
::ng-deep .chart-section .chart-title.orange-bg.sm:before,
::ng-deep .chart-section .chart-title.green-bg.sm:before,
::ng-deep .chart-section .chart-title.purple-bg.sm:before {
  border-width: 0 26px 10px 26px;
}
@media only screen and (max-width: 689px) {
  ::ng-deep .chart-section #chartarea {
    min-width: 320px;
    padding-left: 15px;
  }
  ::ng-deep .chart-section .chart-title {
    width: 52px;
    padding-left: 10px;
    padding-right: 10px;
    white-space: nowrap;
    text-overflow: ellipsis;
    right: -25px;
  }
  ::ng-deep .chart-section .chart-title.blue-bg:before,
  ::ng-deep .chart-section .chart-title.orange-bg:before,
  ::ng-deep .chart-section .chart-title.green-bg:before,
  ::ng-deep .chart-section .chart-title.purple-bg:before {
    border-width: 0 26px 10px 26px;
  }
  ::ng-deep .chart-section .chart-main {
    height: 300px;
    font-size: 14px;
  }
  ::ng-deep .chart-section .chart-title, ::ng-deep .chart-section .side-label, ::ng-deep .chart-section .pointer {
    font-size: 14px;
  }
  ::ng-deep .chart-section .connector_line {
    width: 5px;
  }
  ::ng-deep .chart-section .hidden-xs {
    display: none;
  }
  ::ng-deep .chart-section .visible-xs {
    display: block;
  }
}
@media only screen and (max-width: 767px) {
  ::ng-deep .chart-section .chart-main {
    height: 280px;
  }
  ::ng-deep .result ::ng-deep .chart-section .chart-main {
    height: 130px;
    margin-bottom: 30px;
  }
  ::ng-deep .chart-section .chart-main .preference {
    font-size: 12px;
  }
  ::ng-deep .chart-section .chart-main .high_prefer {
    top: 5px;
  }
  ::ng-deep .chart-section .chart-title {
    width: 52px;
    padding-left: 10px;
    padding-right: 10px;
    white-space: nowrap;
    text-overflow: ellipsis;
    right: -25px;
  }
  body.mini-navbar ::ng-deep .chart-section .chart-title {
    width: 40px !important;
    right: -21px !important;
  }
  ::ng-deep .chart-section .chart-title.blue-bg:before,
  ::ng-deep .chart-section .chart-title.orange-bg:before,
  ::ng-deep .chart-section .chart-title.green-bg:before,
  ::ng-deep .chart-section .chart-title.purple-bg:before {
    border-width: 0 26px 10px 26px;
  }
  body.mini-navbar ::ng-deep .chart-section .chart-title.blue-bg:before,
  body.mini-navbar ::ng-deep .chart-section .chart-title.orange-bg:before,
  body.mini-navbar ::ng-deep .chart-section .chart-title.green-bg:before,
  body.mini-navbar ::ng-deep .chart-section .chart-title.purple-bg:before {
    border-width: 0 20px 10px 20px !important;
  }
  ::ng-deep .chart-section .preference {
    font-size: 14px;
  }
  ::ng-deep .chart-section .pointer {
    transform: translateY(-50%) scale(0.8);
  }
}
@media only screen and (max-width: 390px) {
  ::ng-deep .chart-section #chartarea {
    min-width: 250px;
  }
  ::ng-deep .chart-section .chart-title {
    width: 40px;
  }
  ::ng-deep .chart-section .chart-title.blue-bg:before,
  ::ng-deep .chart-section .chart-title.orange-bg:before,
  ::ng-deep .chart-section .chart-title.green-bg:before,
  ::ng-deep .chart-section .chart-title.purple-bg:before {
    border-width: 0 20px 10px 20px;
  }
}
@media only screen and (max-height: 600px) {
  ::ng-deep .chart-section .chart-main {
    height: 250px;
    font-size: 14px;
  }
  ::ng-deep .chart-section .chart-title, ::ng-deep .chart-section .side-label, ::ng-deep .chart-section .pointer {
    font-size: 14px;
  }
  ::ng-deep .chart-section .chart-title.blue-bg:before, ::ng-deep .chart-section .chart-title.orange-bg:before, ::ng-deep .chart-section .chart-title.green-bg:before, ::ng-deep .chart-section .chart-title.purple-bg:before {
    top: -10px;
  }
  ::ng-deep .chart-section .connector_line {
    width: 5px;
  }
  ::ng-deep .chart-section .highlighter {
    width: 22%;
  }
}

.print-info {
  display: block;
  font-size: 10px;
  margin-top: 5px;
  color: #676a6c;
  margin-bottom: 5px;
}
.print-info a {
  font-size: inherit !important;
}

@media only screen and (max-height: 414px) and (orientation: landscape) {
  .chart-title.sm {
    width: 42px !important;
    right: -21px !important;
    font-size: 12px !important;
  }
  .chart-title.blue-bg.sm:before,
  .chart-title.orange-bg.sm:before,
  .chart-title.green-bg.sm:before,
  .chart-title.purple-bg.sm:before {
    border-width: 0 21px 10px 21px !important;
  }
}
@media print {
  /*#chartarea {
    width: 580px;
  }*/
  .chart-title {
    color: #fff #fff !important;
  }
  .chart-title .visible-xs, .chart-title .hidden-xs {
    color: #fff #fff !important;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/components/fs-graph/fs-graph.component.scss","webpack://./src/assets/styles/_variables.scss"],"names":[],"mappings":"AAAA,4BAAA;ACgIA;EACE,eAAA;AD9HF;;ACiIA;EACE,aAAA;EACA,eAAA;AD9HF;;ACiIA;EACE,sBAAA;AD9HF;;ACiIA;EACE,8BAAA;AD9HF;;ACiIA;EACE,gBAAA;AD9HF;;ACiIA;EACE,gBAAA;AD9HF;;ACiIA;EACE,aAAA;AD9HF;;ACiIA;EACE,gBAAA;AD9HF;;AC4IE;;;;;;EAME,YAAA;EACA,wBA7KO;EA8KP,cA3IiB;EA4IjB,0BAAA;EACA,aAAA;ADzIJ;AC2II;;;;;;EACE,gBAAA;ADpIN;ACwIE;;EAEE,eA5GO;EA6GP,gBA3GO;AD3BX;ACwII;EALF;;IAMI,eA/GY;EDrBhB;AACF;ACuIE;;EAEE,eAlHO;EAmHP,gBAjHO;ADpBX;ACuII;EALF;;IAMI,eArHY;EDdhB;AACF;ACsIE;;EAEE,eAxHO;EAyHP,gBAvHO;ADbX;ACsII;EALF;;IAMI,eA3HY;EDPhB;AACF;ACqIE;;EAEE,eA9HO;EA+HP,gBA7HO;ADNX;ACsIE;;EAEE,eAhIO;EAiIP,gBAhIO;ADJX;ACuIE;;EAEE,eAnIO;EAoIP,gBAnIO;ADFX;AC2IE;EACE,eAAA;EACA,gBAAA;EACA,cAzMqB;EA0MrB,aAAA;EACA,mBAAA;ADzIJ;AC2II;EACE,gBAAA;ADzIN;AC4II;EAXF;IAYI,eAAA;EDzIJ;AACF;AC4IE;;EAEE,UAAA;EACA,SAAA;AD1IJ;AC6IE;EACE,gBAAA;EACA,kBAAA;EACA,QAAA;EACA,qBAAA;EACA,mBAAA;AD3IJ;;AC+IA;EACE,sBAxNQ;AD4EV;;AC+IA;EACE,iBAlKU;EAmKV,wBAAA;EACA,mBAAA;AD5IF;AC8IE;EALF;IAMI,cAAA;ED3IF;AACF;AC6IE;EACE,iBA1Ka;AD+BjB;AC8IE;EACE,gBApLa;EAqLb,WAAA;AD5IJ;;ACiJE;EACE,kBAAA;AD9IJ;ACiJE;EACE,iBAAA;AD/IJ;;ACoJE;EACE,aAAA;ADjJJ;;ACqJA;EACE,kBAAA;ADlJF;ACoJE;EACE,mBAAA;ADlJJ;ACsJI;EACE,sBAAA;ADpJN;ACwJE;EACE,gBAAA;EACA,WAAA;EACA,mBAAA;EACA,eA9Ne;ADwEnB;ACwJI;EACE,sBAAA;ADtJN;ACyJI;EAVF;IAWI,eApOoB;ED8ExB;AACF;ACyJE;EACE,aAAA;EACA,eAAA;EACA,uBAAA;EACA,mBAAA;ADvJJ;ACyJI;EACE,sBAAA;ADvJN;AC0JI;EACE,WAAA;ADxJN;AC2JI;EACE,kBAAA;EACA,oBAAA;EACA,eAAA;EACA,4BA5VM;ADmMZ;;AC8JA;EACE,mBA1PO;AD+FT;AC6JE;EAHF;IAII,mBAAA;ED1JF;AACF;AC4JE;EACE,mBAAA;AD1JJ;AC6JE;EACE,aArQK;AD0GT;AC6JI;EAHF;IAII,aAAA;ED1JJ;AACF;AC4JI;EACE,aAAA;AD1JN;;AC+JA;EACE,gBAAA;EACA,uBAAA;EAAA,kBAAA;EACA,+CAAA;EACA,mBAAA;EACA,kBAAA;AD5JF;AC8JE;EACE,eAAA;AD5JJ;AC+JE;EACE,sCAAA;AD7JJ;ACgKE;EACE,WAAA;EACA,kBAAA;EACA,SAAA;EACA,OAAA;EACA,WAAA;EACA,uBAAA;EACA,oNAAA;AD9JJ;;AC6KE;EACE,eAAA;EACA,gBAAA;EACA,cA/XqB;EAgYrB,gBAAA;EACA,kBAAA;EACA,kBAAA;AD1KJ;AC4KI;EACE,kBAAA;AD1KN;AC6KI;EACE,WAAA;EACA,kBAAA;EACA,SAAA;EACA,OAAA;EACA,UAAA;EACA,WAAA;EACA,mCAAA;AD3KN;;ACgLA;EACE,8BAAA;AD7KF;;ACgLA;EACE,8BAAA;AD7KF;;ACgLA;EACE,+BAAA;AD7KF;;ACgLA;EACE,8BAAA;AD7KF;;ACgLA;EACE,mBAAA;EACA,oBAAA;EACA,mCAzbc;EA0bd,WAzZS;EA0ZT,eAAA;EACA,gBAAA;EACA,qBAAA;EACA,wBAhdS;EAidT,qBAAA;EACA,qBAAA;EACA,kBAAA;EACA,iCAAA;AD7KF;AC+KE;EACE,2BAAA;EACA,mBAAA;AD7KJ;ACgLE;EACE,yBAzbiB;EA0bjB,WA1aO;AD4PX;ACiLE;EACE,eAAA;EACA,mBAAA;EACA,oBAAA;AD/KJ;ACkLE;EACE,yBAjckB;EAkclB,cArciB;ADqRrB;ACmLE;EACE,yBAvbS;EAwbT,WA1bO;ADyQX;ACmLI;EACE,6BAAA;ADjLN;;ACsLA;EACE;IACE,uBAAA;EDnLF;ECsLA;IACE,yBAAA;EDpLF;AACF;ACuLA;EACE,8BAAA;ADrLF;;ACwLA;EACE,8BAAA;ADrLF;;ACwLA;EACE,+BAAA;ADrLF;;ACwLA;EACE,8BAAA;ADrLF;;ACwLA;EACE,qBAAA;ADrLF;;ACwLA;EACE,UAAA;ADrLF;ACuLE;EACE,qBAAA;ADrLJ;;ACyLA;EACE,UAAA;ADtLF;;AC0LE;EACE,YAAA;EACA,oCAAA;EAEA,aAAA;EACA,eAAA;EACA,gCAAA;ADxLJ;AC2LM;EACE,mBAAA;ADzLR;AC8LE;EACE,2BAAA;AD5LJ;AC+LE;EACE,uBAAA;AD7LJ;ACgME;EACE,mBAAA;AD9LJ;;ACmME;EACE,mBAAA;ADhMJ;ACmME;EACE,yBAAA;ADjMJ;ACoME;EACE,sBAAA;ADlMJ;ACqME;EACE,uBAAA;ADnMJ;ACsME;EACE,oBAAA;ADpMJ;;AA3YA;EAIE,UAAA;EACA,sBAAA;EACA,oBAAA;EAEA,iDAAA;EAcA,oCAAA;EAEA,oCAAA;EAWA,gCAAA;EA8BA,gCAAA;EA0BA,kCAAA;EAgBA,iCAAA;EAwBA,iCAAA;EAoCA,kCAAA;EAoDA,oCAAA;EA8CA,wCAAA;EAEA,qCAAA;EA8CA,mCAAA;EAEA,uCAAA;EAoCA,qCAAA;AAiEF;AAvZE;EACE,6CAAA;AAyZJ;AAvZE;EACE,6CAAA;AAyZJ;AAvZE;EACE,8CAAA;AAyZJ;AAvZE;EACE,6CAAA;AAyZJ;AAnZE;EACE,WAAA;EACA,aAAA;EACA,cAAA;EACA,yBAAA;EACA,cAAA;EACA,WAAA;EACA,kBAAA;AAqZJ;AAjZE;EACE,cAAA;EACA,yBAAA;EACA,WAAA;EACA,YAAA;EAEA,SAAA;EACA,QAAA;EACA,yBAAA;AAkZJ;AA/YE;EACE;IACE,kBAAA;EAiZJ;AACF;AA9YE;EACE,4BAAA;EACA,yBAAA;EACA,mBAAA;EACA,UAAA;EACA,mBAAA;EACA,kBAAA;AAgZJ;AA9YE;EACE,2BAAA;AAgZJ;AA5YE;EACE,cAAA;EACA,yBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,OAAA;EACA,MAAA;AA8YJ;AA5YI;EAEE,2BAAA;AA8YN;AA3YE;EACE,yBAAA;EACA,WAAA;EACA,WAAA;EACA,6BAAA;EACA,kBAAA;AA6YJ;AA3YE;EACE,0BAAA;AA6YJ;AAzYE;EACE,eAAA;EACA,oCAAA;EACA,kBAAA;EACA,WAAA;EACA,SAAA;EACA,iBAAA;EACA,WAAA;AA2YJ;AAzYE;EACE,kBAAA;EACA,YAAA;EACA,YAAA;AA2YJ;AAvYE;EACE,kBAAA;EACA,WAAA;EACA,YAAA;EACA,OAAA;EACA,MAAA;EACA,eAAA;EACA,eAAA;EACA,gBAAA;AAyYJ;AAvYE;EACE,kBAAA;EACA,SAAA;EACA,oCAAA;EACA,UAAA;AAyYJ;AAvYE;EACE,kBAAA;EACA,YAAA;EACA,oCAAA;EACA,UAAA;AAyYJ;AArYE;EACE,cAAA;EACA,kBAAA;EACA,mBAAA;EACA,8BAAA;EACA,kBAAA;EACA,kBAAA;EACH;0BAAA;EAEG,UAAA;EACA,WAAA;EAIA,gBAAA;AAoYJ;AAlYE;EACE,QAAA;EACA,qBAAA;EAGA,2BAAA;AAoYJ;AAlYE;EACE,kBAAA;EACA,OAAA;EACA,eAAA;AAoYJ;AAlYE;EACE,UAAA;AAoYJ;AAlYE;EACE,aAAA;AAoYJ;AAhYE;EACE,yBAAA;EACA,eAAA;EACA,sBAAA;EACA,qBAAA;EACA,YAAA;EACA,YAAA;EACA,kBAAA;EACA,kBAAA;EACA,aAAA;EACA,YAAA;EACA,eAAA;EACA,WAAA;AAkYJ;AAhYI;EACE,aAAA;AAkYN;AA9XE;;;;EAIE,WAAA;EACA,kBAAA;EACA,UAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,mBAAA;EACA,gBAAA;EACA,8BAAA;GAgYF,iEA/XE;AAgYJ;AA9XE;EACE,kEAAA;GAgYF,sDA/XE;AAgYJ;AA9XE;EACE,kEAAA;GAgYF,sDA/XE;AAgYJ;AA9XE;EACE,mEAAA;GAgYF,uDA/XE;AAgYJ;AA9XE;EACE,kEAAA;GAgYF,sDA/XE;AAgYJ;AA5XE;EACE,kBAAA;EACA,OAAA;EACA,MAAA;EACA,WAAA;EACA,YAAA;EACA,UAAA;AA8XJ;AA5XE;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,qBAAA;EACA,kBAAA;EACA,OAAA;EACA,SAAA;EACA,sBAAA;EACA,gBAAA;EACA,eAAA;EACA,kBAAA;EACA,iBAAA;EAGA,2BAAA;EACA,oBAAA;AA8XJ;AA5XE;EACE,0BAAA;EACA,sBAAA;AA8XJ;AA5XE;EACE,0BAAA;EACA,yBAAA;EACA,sBAAA;AA8XJ;AA5XE;EACE,0BAAA;EACA,yBAAA;EACA,sBAAA;AA8XJ;AA5XE;EACE,0BAAA;EACA,yBAAA;EACA,sBAAA;AA8XJ;AAzXE;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,OAAA;EACA,MAAA;AA2XJ;AAzXE;EACE,kBAAA;EACA,MAAA;EACA,SAAA;EACA,UAAA;EACA,UAAA;AA2XJ;AAzXE;EACE,gBAAA;AA2XJ;AAzXE;EACE,gBAAA;AA2XJ;AAzXE;EACE,gBAAA;AA2XJ;AAzXE;EACE,kBAAA;EACA,UAAA;EACA,iBAAA;EACA,oCAAA;AA2XJ;AAzXE;EACE,kBAAA;EAGA,2BAAA;EACA,WAAA;EACA,YAAA;EACA,oBAAA;AA2XJ;AAzXE;EACE,WAAA;AA2XJ;AAxXE;EACE,YAAA;AA0XJ;AArXE;EACE,kBAAA;EACA,OAAA;EACA,SAAA;EACA,YAAA;EACA,WAAA;EACA,UAAA;AAuXJ;AArXE;EACE,UAAA;EACA,gBAAA;EACA,YAAA;EACA,kBAAA;EACA,kBAAA;EACA,MAAA;EAGA,2BAAA;AAuXJ;AArXE;EACE,qDAAA;EACA,SAAA;AAuXJ;AArXE;EACE,qDAAA;EACA,SAAA;AAuXJ;AArXE;EACE,oDAAA;EACA,SAAA;AAuXJ;AArXE;EACE,oDAAA;EACA,SAAA;AAuXJ;AAnXE;EACE,cAAA;AAqXJ;AAnXE;EACE,aAAA;AAqXJ;AAlXE;EACE,yBAAA;AAoXJ;AAlXE;EACE,wBAAA;AAoXJ;AAjXE;EACE,WAAA;EACA,kBAAA;EACA,mBAAA;EACA,mBAAA;EACA,uBAAA;EACA,YAAA;EACA,0BAAA;EACA,eAAA;AAmXJ;AAjXE;;;;EAIE,8BAAA;AAmXJ;AAhXE;EACE;IACE,gBAAA;IACA,kBAAA;EAkXJ;EAhXE;IACE,WAAA;IACA,kBAAA;IACA,mBAAA;IACA,mBAAA;IACA,uBAAA;IACA,YAAA;EAkXJ;EAhXE;;;;IAIE,8BAAA;EAkXJ;EAhXE;IACE,aAAA;IACA,eAAA;EAkXJ;EAhXE;IACE,eAAA;EAkXJ;EAhXE;IACE,UAAA;EAkXJ;EAhXE;IACE,aAAA;EAkXJ;EAhXE;IACE,cAAA;EAkXJ;AACF;AA/WE;EACI;IACE,aAAA;EAiXN;EA/WM;IACE,aAAA;IACA,mBAAA;EAiXR;EA9WM;IACE,eAAA;EAgXR;EA9WM;IACE,QAAA;EAgXR;EAxVI;IACE,WAAA;IACA,kBAAA;IACA,mBAAA;IACA,mBAAA;IACA,uBAAA;IACA,YAAA;EA0VN;EAxVM;IACE,sBAAA;IACA,uBAAA;EA0VR;EAvVI;;;;IAIE,8BAAA;EAyVN;EAvVM;;;;IACE,yCAAA;EA4VR;EAzVI;IACE,eAAA;EA2VN;EAzVI;IAKE,sCAAA;EA2VN;AACF;AAxVE;EACE;IACE,gBAAA;EA0VJ;EAxVE;IACE,WAAA;EA0VJ;EAxVE;;;;IAIE,8BAAA;EA0VJ;AACF;AAvVE;EACE;IACE,aAAA;IACA,eAAA;EAyVJ;EAvVE;IACE,eAAA;EAyVJ;EAvVE;IACE,UAAA;EAyVJ;EAvVE;IACE,UAAA;EAyVJ;EAvVE;IACE,UAAA;EAyVJ;AACF;;AApVA;EACE,cAAA;EACA,eAAA;EACA,eAAA;EACA,cCtfmB;EDufnB,kBAAA;AAuVF;AArVE;EACE,6BAAA;AAuVJ;;AAnVA;EAEE;IACE,sBAAA;IACA,uBAAA;IACA,0BAAA;EAqVF;EAnVA;;;;IAIE,yCAAA;EAqVF;AACF;AAlVA;EACE;;IAAA;EAGA;IACE,2BAAA;EAoVF;EAnVE;IACE,2BAAA;EAqVJ;AACF","sourcesContent":["/* style-for-Profile-chart */\n@import './../../../assets/styles/variables';\n\n\n\n::ng-deep .chart-section {\n\n  //padding: 25px 0 43px 0;\n  // min-width: 580px;\n  width: 90%;\n  margin: 5% auto 0 auto;\n  padding-bottom: 20px;\n\n  /*------background colors used in chart---------*/\n  .blue-bg {\n    background-color: $clarify-color !important;\n  }\n  .orange-bg {\n    background-color: $ideate-color !important;\n  }\n  .green-bg {\n    background-color: $develop-color !important;\n  }\n  .purple-bg {\n    background-color: $implement-color !important;\n  }\n\n  /*------chart area wrapper---------*/\n\n  /*------main chart wrapper---------*/\n  .chart-main {\n    width: 100%;\n    height: 250px;\n    display: table;\n    border-collapse: collapse;\n    margin: 0 auto;\n    float: none;\n    position: relative;\n  }\n\n  /*------y dividers css---------*/\n  .y-dividers {\n    display: table;\n    border-collapse: collapse;\n    width: 100%;\n    height: 100%;\n    //position: absolute;\n    left:0px;\n    top:0px;\n    border:3px solid #d1d2d4;\n  }\n\n  @media screen and (-ms-high-contrast: active), (-ms-high-contrast: none) {\n    .y-dividers {\n      position: absolute;\n    }\n  }\n\n  .dividers-yxis {\n    border-right: 1px solid #eee;\n    border-collapse: collapse;\n    display: table-cell;\n    width: 20%;\n    table-layout: fixed;\n    position: relative;\n  }\n  .dividers-yxis:first-child {\n    border-left: 1px solid #eee;\n  }\n\n  /*------x dividers css---------*/\n  .x-dividers {\n    display: block;\n    border-collapse: collapse;\n    width: 100%;\n    height: 100%;\n    position: absolute;\n    left: 0;\n    top: 0;\n\n    .owl-carousel &{\n      -webkit-backface-visibility: hidden;\n      backface-visibility: hidden;\n    }\n  }\n  .dividers-xxis {\n    border-collapse: collapse;\n    width: 100%;\n    height: 20%;\n    border-bottom: 1px solid #eee;\n    position: relative;\n  }\n  .dividers-xxis:first-child {\n    border-top: 1px solid #eee;\n  }\n\n  /*------chart labels css---------*/\n  .side-label {\n    font-size: 16px;\n    color: rgba(0, 0, 0, .4) !important;\n    position: absolute;\n    left: -25px;\n    top: -8px;\n    text-align: right;\n    width: 20px;\n  }\n  .label-0 {\n    position: absolute;\n    top: inherit;\n    bottom: -8px;\n  }\n\n  /*------preferences css---------*/\n  .preference {\n    position: absolute;\n    width: 100%;\n    height: 100%;\n    left: 0;\n    top: 0;\n    padding: 0 30px;\n    font-size: 16px;\n    font-weight: 500;\n  }\n  .high_prefer {\n    position: absolute;\n    top: 20px;\n    color: rgba(0, 0, 0, .4) !important;\n    left:30px;\n  }\n  .low_prefer {\n    position: absolute;\n    bottom: 20px;\n    color: rgba(0, 0, 0, .4) !important;\n    left:30px;\n  }\n\n  /*------neutral bar css---------*/\n  .neutral {\n    display: block;\n    margin-left: -30px;\n    margin-right: -30px;\n    background: $integrator-color !important;\n    position: absolute;\n    padding-left: 30px;\n /*   padding-top: 5px;\n    padding-bottom: 5px;*/\n    z-index: 1;\n    width: 100%;\n    // -webkit-transform: translateY(-50%);\n    // -ms-transform: translateY(-50%);\n    // transform: translateY(-50%);\n    text-align: left;\n  }\n  .neutralBartext{\n    top:50%;\n    left:20px !important;\n    -webkit-transform: translateY(-50%);\n    -ms-transform: translateY(-50%);\n    transform:translateY(-50%);\n  }\n  .neutral span {\n    position: absolute;\n    left: 0;\n    font-size: 12px;\n  }\n  .neutral_high_value {\n    top: -15px;\n  }\n  .neutral_low_value {\n    bottom: -15px;\n  }\n\n  /*------chart titles css---------*/\n  .chart-title {\n    text-transform: uppercase;\n    font-size: 14px;\n    color: $color-light-type !important;\n    display: inline-block;\n    padding: 5px;\n    width: 110px;\n    text-align: center;\n    position: absolute;\n    bottom: -23px;\n    right: -55px;\n    cursor: pointer;\n    z-index: 99;\n\n    html.mac.safari &{\n      bottom:-45px;\n    }\n  }\n\n  .chart-title.blue-bg:before,\n  .chart-title.orange-bg:before,\n  .chart-title.green-bg:before,\n  .chart-title.purple-bg:before {\n    content: \"\";\n    position: absolute;\n    top: -10px;\n    left: 0;\n    width: 0;\n    height: 0;\n    border-style: solid;\n    line-height: 0px;\n    border-width: 0 55px 10px 55px;\n    _filter: progid:DXImageTransform.Microsoft.Chroma(color='#000000');\n  }\n  .chart-title.blue-bg:before {\n    border-color: transparent transparent $clarify-color transparent;\n    _border-color: #000000 #000000 $clarify-color #000000;\n  }\n  .chart-title.orange-bg:before {\n    border-color: transparent transparent $ideate-color transparent;\n    _border-color: #000000 #000000 $ideate-color #000000;\n  }\n  .chart-title.green-bg:before {\n    border-color: transparent transparent $develop-color transparent;\n    _border-color: #000000 #000000 $develop-color #000000;\n  }\n  .chart-title.purple-bg:before {\n    border-color: transparent transparent $implement-color transparent;\n    _border-color: #000000 #000000 $implement-color #000000;\n  }\n\n  /*------chart pointers css---------*/\n  .chart_pointers {\n    position: absolute;\n    left: 0;\n    top: 0;\n    width: 100%;\n    height: 100%;\n    z-index: 5;\n  }\n  .pointer {\n    width: 35px;\n    height: 35px;\n    border-radius: 50%;\n    display: inline-block;\n    position: absolute;\n    left: 0;\n    bottom: 0;\n    color: $color-light-type !important;\n    font-weight: 600;\n    font-size: 16px;\n    text-align: center;\n    line-height: 35px;\n    -webkit-transform: translateY(-50%);\n    -ms-transform: translateY(-50%);\n    transform: translateY(-50%);\n    margin-bottom: -35px;\n  }\n  .pointer.clarify_pointer {\n    left: -ms-calc(20% - 17px);\n    left: calc(20% - 17px);\n  }\n  .pointer.ideate_pointer {\n    left: -ms-calc(40% - 17px);\n    left: -o-calc(40% - 17px);\n    left: calc(40% - 17px);\n  }\n  .pointer.develop_pointer {\n    left: -ms-calc(60% - 17px);\n    left: -o-calc(60% - 17px);\n    left: calc(60% - 17px);\n  }\n  .pointer.implement_pointer {\n    left: -ms-calc(80% - 17px);\n    left: -o-calc(80% - 17px);\n    left: calc(80% - 17px);\n  }\n  /*------chart pointers css end---------*/\n\n  /*------connector css start---------*/\n  .connectors {\n    width: 100%;\n    height: 100%;\n    position: absolute;\n    left: 0;\n    top: 0;\n  }\n  .connector_block {\n    position: absolute;\n    top: 0;\n    bottom: 0;\n    width: 20%;\n    z-index: 4;\n  }\n  .block1 {\n    margin-left: 20%;\n  }\n  .block2 {\n    margin-left: 60%;\n  }\n  .block3 {\n    margin-left: 40%;\n  }\n  .connector_line {\n    position: absolute;\n    width: 8px;\n    margin-top: -15px;\n    background-color: $profile-connector-color !important;\n  }\n  .connector_point {\n    position: absolute;\n    -webkit-transform: translateY(-50%);\n    -ms-transform: translateY(-50%);\n    transform: translateY(-50%);\n    width: 35px;\n    height: 35px;\n    margin-bottom: -35px;\n  }\n  #connector_clarify_pointer, #connector_develop_pointer, #mid_connector_1 {\n    left: -17px;\n  }\n\n  #connector_ideate_pointer, #connector_implement_pointer, #mid_connector_2 {\n    right: -17px;\n  }\n  /*------connector css end---------*/\n\n  /*------highlighter css start---------*/\n  .highlighter-wrap {\n    position: absolute;\n    left: 0;\n    top: -10%;\n    bottom: -20%;\n    width: 100%;\n    z-index: 5;\n  }\n  .highlighter {\n    width: 30%;\n    max-width: 200px;\n    height: 100%;\n    border-radius: 50%;\n    position: absolute;\n    top: 0;\n    -webkit-transform: translateX(-50%);\n    -ms-transform: translateX(-50%);\n    transform: translateX(-50%);\n  }\n  .highlighter.clarify_active {\n    background-color: rgba(21, 165, 207, 0.25) !important;\n    left: 20%;\n  }\n  .highlighter.ideate_active {\n    background-color: rgba(249, 121, 19, 0.25) !important;\n    left: 40%;\n  }\n  .highlighter.develop_active {\n    background-color: rgba(97, 194, 11, 0.25) !important;\n    left: 60%;\n  }\n  .highlighter.implement_active {\n    background-color: rgba(238, 40, 69, 0.25) !important;\n    left: 80%;\n  }\n  /*------highlighter css end---------*/\n\n  .hidden-xs {\n    display: block;\n  }\n  .visible-xs {\n    display: none;\n  }\n\n  .chart-title.sm .visible-xs{\n    display:block !important;\n  }\n  .chart-title.sm .hidden-xs{\n    display:none !important;\n  }\n\n  .chart-title.sm{\n    width: 52px;\n    padding-left: 10px;\n    padding-right: 10px;\n    white-space: nowrap;\n    text-overflow: ellipsis;\n    right: -25px;\n    text-transform: capitalize;\n    font-size: 14px;\n  }\n  .chart-title.blue-bg.sm:before,\n  .chart-title.orange-bg.sm:before,\n  .chart-title.green-bg.sm:before,\n  .chart-title.purple-bg.sm:before{\n    border-width: 0 26px 10px 26px;\n  }\n\n  @media only screen and (max-width: 689px) {\n    #chartarea {\n      min-width: 320px;\n      padding-left: 15px;\n    }\n    .chart-title {\n      width: 52px;\n      padding-left: 10px;\n      padding-right: 10px;\n      white-space: nowrap;\n      text-overflow: ellipsis;\n      right: -25px;\n    }\n    .chart-title.blue-bg:before,\n    .chart-title.orange-bg:before,\n    .chart-title.green-bg:before,\n    .chart-title.purple-bg:before {\n      border-width: 0 26px 10px 26px;\n    }\n    .chart-main {\n      height: 300px;\n      font-size: 14px;\n    }\n    .chart-title, .side-label, .pointer {\n      font-size: 14px;\n    }\n    .connector_line {\n      width: 5px;\n    }\n    .hidden-xs {\n      display: none;\n    }\n    .visible-xs {\n      display: block;\n    }\n  }\n\n  @media only screen and (max-width: 767px) {\n      .chart-main {\n        height:280px;\n\n        ::ng-deep .result &{\n          height:130px;\n          margin-bottom: 30px;\n        }\n\n        .preference{\n          font-size: 12px;\n        }\n        .high_prefer{\n          top: 5px;\n        }\n        // .low_prefer{\n        //   bottom: 5px;\n        // }\n      }\n\n      // .chart-title.sm{\n      //   width: 52px;\n      //   padding-left: 10px;\n      //   padding-right: 10px;\n      //   white-space: nowrap;\n      //   text-overflow: ellipsis;\n      //   right: -25px;\n      //   text-transform: capitalize;\n      //   font-size: 14px;\n      // }\n      // .chart-title.blue-bg.sm:before,\n      // .chart-title.orange-bg.sm:before,\n      // .chart-title.green-bg.sm:before,\n      // .chart-title.purple-bg.sm:before{\n      //   border-width: 0 26px 10px 26px;\n      // }\n\n      .chart-title {\n        width: 52px;\n        padding-left: 10px;\n        padding-right: 10px;\n        white-space: nowrap;\n        text-overflow: ellipsis;\n        right: -25px;\n\n        body.mini-navbar &{\n          width: 40px !important;\n          right:-21px !important;\n        }\n      }\n      .chart-title.blue-bg:before,\n      .chart-title.orange-bg:before,\n      .chart-title.green-bg:before,\n      .chart-title.purple-bg:before {\n        border-width: 0 26px 10px 26px;\n\n        body.mini-navbar &{\n          border-width:0 20px 10px 20px !important;\n        }\n      }\n      .preference {\n        font-size: 14px;\n      }\n      .pointer{\n        -webkit-transform:translateY(-50%) scale(0.8);\n        -moz-transform:translateY(-50%) scale(0.8);\n        -ms-transform:translateY(-50%) scale(0.8);\n        -o-transform:translateY(-50%) scale(0.8);\n        transform:translateY(-50%) scale(0.8);\n      }\n  }\n\n  @media only screen and (max-width: 390px) {\n    #chartarea {\n      min-width: 250px;\n    }\n    .chart-title {\n      width: 40px;\n    }\n    .chart-title.blue-bg:before,\n    .chart-title.orange-bg:before,\n    .chart-title.green-bg:before,\n    .chart-title.purple-bg:before {\n      border-width: 0 20px 10px 20px;\n    }\n  }\n\n  @media only screen and (max-height: 600px) {\n    .chart-main {\n      height: 250px;\n      font-size: 14px;\n    }\n    .chart-title, .side-label, .pointer {\n      font-size: 14px;\n    }\n    .chart-title.blue-bg:before, .chart-title.orange-bg:before, .chart-title.green-bg:before, .chart-title.purple-bg:before {\n      top: -10px;\n    }\n    .connector_line {\n      width: 5px;\n    }\n    .highlighter {\n      width: 22%;\n    }\n  }\n}\n\n\n.print-info {\n  display: block;\n  font-size: 10px;\n  margin-top: 5px;\n  color: $body-content-color;\n  margin-bottom: 5px;\n\n  a{\n    font-size: inherit !important;\n  }\n}\n\n@media only screen and (max-height: 414px) and (orientation:landscape) {\n\n  .chart-title.sm{\n    width: 42px !important;\n    right: -21px !important;\n    font-size: 12px !important;\n  }\n  .chart-title.blue-bg.sm:before,\n  .chart-title.orange-bg.sm:before,\n  .chart-title.green-bg.sm:before,\n  .chart-title.purple-bg.sm:before{\n    border-width: 0 21px 10px 21px !important;\n  }\n}\n\n@media print {\n  /*#chartarea {\n    width: 580px;\n  }*/\n  .chart-title{\n    color:$color-light-type$color-light-type !important;\n    .visible-xs, .hidden-xs{\n      color:$color-light-type$color-light-type !important;\n    }\n  }\n}\n    \n","// Font\n$font-stack: \"open sans\", \"Helvetica Neue\", Helvetica, Arial, sans-serif;\n$muso-100: \"Museo-100\";\n$muso-300: \"Museo-300\";\n$muso-300-i: \"Museo-300Italic\";\n$muso-500: \"Museo-regular\";\n$muso-700: \"Museo-700\";\n$muso-700-i: \"Museo-700Italic\";\n$muso-sans: \"MuseoSans-300\";\n$car-font: \"Marydale\";\n$car-big-font: \"Bangers\", cursive;\n$font-museo: \"Conv_museo-500-webfont\";\n$font-helvetica: \"Helvetica\", \"open sans\";\n$MuseoSansCondensed-300: \"MuseoSansCondensed-300\";\n\n$fwBold: 700;\n\n//Foursight\n// $clarify-color: #06A6CE;\n// $ideate-color: #FF8300;\n// $develop-color: #7BBC43;\n// $implement-color: #FF485C;\n$clarify-color: rgba(0, 173, 208, 1);\n$ideate-color: rgba(255, 121, 0, 1);\n$develop-color: rgba(105, 190, 40, 1);\n$implement-color: rgba(245, 67, 89, 1);\n$low-clarify-color: rgba(0, 173, 208, 1);\n$low-ideate-color: rgba(255, 121, 0, 1);\n$low-develop-color: rgba(105, 190, 40, 1);\n$low-implement-color: rgba(245, 67, 89, 1);\n$profile-connector-color: #656668;\n// Profile Neutral color\n$integrator-color: #e3e3e3;\n// Team Report\n$report-integrator: #a7a7a7;\n// Body text color in reports\n$body-content-color: #676a6c;\n// Learner Map\n$gray-lm: rgba(0, 0, 0, 0.2);\n$border-color: #aaa;\n\n$color-neutral-dark: #6d6e71;\n$color-neutral-dark-500: #6a6a6a;\n$color-neutral-mid: #ccc;\n$color-neutral-light: #f1f1f2;\n$color-neutral-mid-old: #9e9e97;\n$color-dark-green: #4cae4c;\n$color-light-grey: #d9d9d9;\n$color-red: #ff485c;\n\n$color-grey-1: #e7eaec;\n\n$clrGray1: #f6f6f6;\n\n$clrDarkGray1: #ddd;\n\n$clrGrey: #eee;\n$clrWhite: #fff;\n$clrBlack: #000;\n$clrWarning: #f8ac59;\n\n$assets: \"https://assets.foursightonline.com/app\";\n$adminUpload: \"https://assets.foursightonline.com/admin-uploads/docs/\";\n\n$separator: \"\\//\";\n\n$active-class: #017ebc;\n\n// anchor Tag\n$anchor-color: #337ab7;\n\n//Sidebar\n$color-light-type: #fff;\n// submenu background\n$fs-dark-grey: #464646;\n// Hover\n$fs-active-light: #5f5f63;\n$fs-sidenav-bg: #333333;\n$fs-sidenav-hov-bg: #3e3e3f;\n$fs-green: #69be28;\n\n$clrInputAccent: #639935;\n\n$fn-fs-h1: 44px;\n$fn-fs-h1-mobile: 38px;\n$fn-lh-h1: 1.1;\n\n$fn-fs-h2: 38px;\n$fn-fs-h2-mobile: 32px;\n$fn-lh-h2: 1.2;\n\n$fn-fs-h3: 32px;\n$fn-fs-h3-mobile: 24px;\n$fn-lh-h3: 1.2;\n\n$fn-fs-h4: 24px;\n$fn-fs-h4-mobile: 20px;\n$fn-lh-h4: 1.2;\n\n$fn-fs-h5: 18px;\n$fn-lh-h5: 1.2;\n\n$fn-fs-h6: 16px;\n$fn-lh-h6: 1.3;\n\n$fn-title-subtext: 22px;\n$fn-title-subtext-mobile: 18px;\n\n$pageWidth: 1080px;\n$pageWidthSmall: 820px;\n$pageWidthFluid: 1200px;\n\n$secPad: 60px;\n\n$pageWidth: 1080px;\n$pageWidthFluid: 1200px;\n\n$desktop: \"only screen and (max-width: 1600px)\";\n$mac: \"only screen and (max-width: 1350px)\";\n$pc-up: \"only screen and (min-width: 1200px)\";\n$pc: \"only screen and (max-width: 1199px)\";\n$tablet-up: \"only screen and (min-width: 992px)\";\n$tablet: \"only screen and (max-width: 991px)\";\n$mobile-up: \"only screen and (min-width: 768px)\";\n$mobile: \"only screen and (max-width: 767px)\";\n$xl: \"only screen and (max-width: 1440px)\";\n$xl-up: \"only screen and (min-width: 1440px)\";\n\nimg {\n  max-width: 100%;\n}\n\n.flex {\n  display: flex;\n  flex-wrap: wrap;\n}\n\n.dir-col {\n  flex-direction: column;\n}\n\n.dir-col-rev {\n  flex-direction: column-reverse;\n}\n\n.mh-full {\n  min-height: 100%;\n}\n\n.mt-auto {\n  margin-top: auto;\n}\n\n.bt-0 {\n  border-top: 0;\n}\n\n.bb-0 {\n  border-bottom: 0;\n}\n\n@mixin headingfont() {\n  font-family: $muso-700 !important;\n  font-weight: normal !important;\n}\n\n@mixin contentfont() {\n  font-family: $muso-300 !important;\n  font-weight: normal !important;\n}\n\n.fn-body {\n  h1,\n  h2,\n  h3,\n  h4,\n  h5,\n  h6 {\n    --hGap: 10px;\n    font-family: $muso-700;\n    color: $color-neutral-dark;\n    margin-bottom: var(--hGap);\n    margin-top: 0;\n\n    &:last-child {\n      margin-bottom: 0;\n    }\n  }\n\n  h1,\n  .h1-text {\n    font-size: $fn-fs-h1;\n    line-height: $fn-lh-h1;\n\n    @media #{$mobile} {\n      font-size: $fn-fs-h1-mobile;\n    }\n  }\n\n  h2,\n  .h2-text {\n    font-size: $fn-fs-h2;\n    line-height: $fn-lh-h2;\n\n    @media #{$mobile} {\n      font-size: $fn-fs-h2-mobile;\n    }\n  }\n\n  h3,\n  .h3-text {\n    font-size: $fn-fs-h3;\n    line-height: $fn-lh-h3;\n\n    @media #{$mobile} {\n      font-size: $fn-fs-h3-mobile;\n    }\n  }\n\n  h4,\n  .h4-text {\n    font-size: $fn-fs-h4;\n    line-height: $fn-lh-h4;\n  }\n\n  h5,\n  .h5-text {\n    font-size: $fn-fs-h5;\n    line-height: $fn-lh-h5;\n  }\n\n  h6,\n  .h6-text {\n    font-size: $fn-fs-h6;\n    line-height: $fn-lh-h6;\n  }\n\n  $fn-title-subtext: 22px;\n  $fn-title-subtext-mobile: 18px;\n\n  p {\n    font-size: 18px;\n    line-height: 1.6;\n    color: $color-neutral-dark-500;\n    margin-top: 0;\n    margin-bottom: 10px;\n\n    &:last-child {\n      margin-bottom: 0;\n    }\n\n    @media #{$mobile} {\n      font-size: 16px;\n    }\n  }\n\n  ul,\n  ol {\n    padding: 0;\n    margin: 0;\n  }\n\n  sup {\n    font-size: 0.7em;\n    position: relative;\n    top: 5px;\n    display: inline-block;\n    vertical-align: top;\n  }\n}\n\n.bg-grey {\n  background-color: $clrGrey;\n}\n\n.fn-container {\n  max-width: $pageWidth;\n  width: calc(100% - 30px);\n  margin-inline: auto;\n\n  @media #{$tablet-up} {\n    margin-left: 0;\n  }\n\n  &--fluid {\n    max-width: $pageWidthFluid;\n  }\n\n  &--small {\n    max-width: $pageWidthSmall;\n    width: 100%;\n  }\n}\n\n.text {\n  &-center {\n    text-align: center;\n  }\n\n  &-right {\n    text-align: right;\n  }\n}\n\n.d {\n  &-none {\n    display: none;\n  }\n}\n\n.section-title {\n  text-align: center;\n\n  &:not(:last-child) {\n    margin-bottom: calc($secPad - 20px);\n  }\n\n  h2 {\n    &:not(:last-child) {\n      margin-block-end: calc($secPad / 3);\n    }\n  }\n\n  p {\n    max-width: 900px;\n    width: 100%;\n    margin-inline: auto;\n    font-size: $fn-title-subtext;\n\n    &:not(:last-child) {\n      margin-block-end: calc($secPad / 3);\n    }\n\n    @media #{$mobile} {\n      font-size: $fn-title-subtext-mobile;\n    }\n  }\n\n  .section-title__linkcontainer {\n    display: flex;\n    flex-wrap: wrap;\n    justify-content: center;\n    align-items: center;\n\n    &:not(:last-child) {\n      margin-block-end: 20px;\n    }\n\n    & > * {\n      margin: 5px;\n    }\n\n    .fn-btn {\n      padding-block: 6px;\n      padding-inline: 13px;\n      font-size: 12px;\n      font-family: $muso-sans;\n    }\n  }\n}\n\n.section-padding {\n  padding-block: $secPad;\n\n  @media #{$mobile} {\n    padding-block: ($secPad - 20px);\n  }\n\n  &-small {\n    padding-block: calc($secPad / 2);\n  }\n\n  &-all {\n    padding: $secPad;\n\n    @media #{$mobile} {\n      padding: calc($secPad / 2);\n    }\n\n    &-small {\n      padding: calc($secPad / 2);\n    }\n  }\n}\n\n.headline {\n  --lineSize: 10px;\n  width: fit-content;\n  padding-block-end: calc(10px + var(--lineSize));\n  margin-inline: auto;\n  position: relative;\n\n  &--small-border {\n    --lineSize: 6px;\n  }\n\n  &:not(:last-child) {\n    margin-bottom: calc(var(--hGap) * 2.5);\n  }\n\n  &::before {\n    content: \"\";\n    position: absolute;\n    bottom: 0;\n    left: 0;\n    width: 100%;\n    height: var(--lineSize);\n    background: linear-gradient(\n      90deg,\n      $clarify-color 0%,\n      $clarify-color 25%,\n      $ideate-color 25%,\n      $ideate-color 50%,\n      $develop-color 50%,\n      $develop-color 75%,\n      $implement-color 75%,\n      $implement-color 100%\n    );\n  }\n}\n\n.custom-list {\n  li {\n    font-size: 18px;\n    line-height: 1.4;\n    color: $color-neutral-dark-500;\n    list-style: none;\n    position: relative;\n    padding-left: 15px;\n\n    &:not(:last-child) {\n      margin-bottom: 4px;\n    }\n\n    &::before {\n      content: \"\";\n      position: absolute;\n      top: 10px;\n      left: 0;\n      width: 3px;\n      height: 3px;\n      background-color: var(--clrProfile);\n    }\n  }\n}\n\n.color-clarify {\n  --clrProfile: #{$clarify-color};\n}\n\n.color-ideate {\n  --clrProfile: #{$ideate-color};\n}\n\n.color-develop {\n  --clrProfile: #{$develop-color};\n}\n\n.color-implement {\n  --clrProfile: #{$implement-color};\n}\n\n.fn-btn {\n  padding-block: 20px;\n  padding-inline: 28px;\n  background-color: $develop-color;\n  color: $clrWhite;\n  font-size: 18px;\n  line-height: 1.2;\n  display: inline-block;\n  font-family: $muso-700;\n  text-decoration: none;\n  word-break: break-all;\n  text-align: center;\n  transition: background-color 0.3s;\n\n  &:focus {\n    outline: 1px dashed $color-neutral-dark-500;\n    outline-offset: 4px;\n  }\n\n  &:hover {\n    background-color: $color-neutral-dark;\n    color: $clrWhite;\n  }\n\n  &--sm {\n    font-size: 14px;\n    padding-block: 10px;\n    padding-inline: 20px;\n  }\n\n  &--grey {\n    background-color: $color-neutral-light;\n    color: $color-neutral-dark;\n  }\n\n  &--ongoing {\n    background-color: $clrWarning;\n    color: $clrWhite;\n\n    i {\n      animation: spin 0.3s infinite;\n    }\n  }\n}\n\n@keyframes spin {\n  from {\n    transform: rotate(0deg);\n  }\n\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n.color-clarify {\n  --clrProfile: #{$clarify-color};\n}\n\n.color-ideate {\n  --clrProfile: #{$ideate-color};\n}\n\n.color-develop {\n  --clrProfile: #{$develop-color};\n}\n\n.color-implement {\n  --clrProfile: #{$implement-color};\n}\n\n.w-4 {\n  width: calc(100% / 3);\n}\n\n.w-3 {\n  width: calc(100% / 4);\n\n  &--wd {\n    width: calc(100% / 3);\n  }\n}\n\n.w-6 {\n  width: calc(100% / 2);\n}\n\n.fn {\n  &-row {\n    --rGap: 15px;\n    --rGap-minus: calc(-1 * var(--rGap));\n\n    display: flex;\n    flex-wrap: wrap;\n    margin-inline: var(--rGap-minus);\n\n    &--col-gap-exist {\n      .fn-col {\n        margin-bottom: calc($secPad / 2);\n      }\n    }\n  }\n\n  &-col {\n    padding-inline: var(--rGap);\n  }\n\n  &-justify-center {\n    justify-content: center;\n  }\n\n  &-items-center {\n    align-items: center;\n  }\n}\n\n.m {\n  &x-auto {\n    margin-inline: auto;\n  }\n\n  &l-auto {\n    margin-inline-start: auto;\n  }\n\n  &l-0 {\n    margin-inline-start: 0;\n  }\n\n  &r-auto {\n    margin-inline-end: auto;\n  }\n\n  &r-0 {\n    margin-inline-end: 0;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
